/* PROTOCOL flow v6 · stepper

   join-protocol rendered three steps: "✓ Your info" (done, clickable),
   "2 Add-ons" (active), "3 Payment". The info step no longer exists, so a
   first-time visitor was told they had completed something they never saw,
   and the tick was clickable straight into goStep(0), which throws because
   panel-0 was removed with the gate.

   Rebuilt as two steps to match add-ons and renew: 1 Add-ons, 2 Payment.
   Nothing is clickable: payment is Shopify checkout and off-site, and there
   is nothing behind add-ons to go back to. */
(function(){
  'use strict';

  function build(){
    var s = document.getElementById('stepper');
    if(!s) return false;
    if(s.dataset.v6 === '1') return true;

    var items = s.querySelectorAll('.step-item');
    if(items.length < 3) { s.dataset.v6 = '1'; return true; }   /* already 2 steps */

    s.innerHTML =
      '<button class="step-item active" type="button" tabindex="-1">' +
        '<span class="dot">1</span><span>Add-ons</span></button>' +
      '<div class="step-line"></div>' +
      '<button class="step-item" type="button" tabindex="-1">' +
        '<span class="dot">2</span><span>Payment</span></button>';
    s.dataset.v6 = '1';
    return true;
  }

  function guard(){
    /* close the last route into the removed panel */
    if(typeof window.goStep === 'function' && !window.goStep.__v6){
      var orig = window.goStep;
      var wrapped = function(n){ if(n < 1) return; return orig.apply(this, arguments); };
      wrapped.__v6 = true;
      window.goStep = wrapped;
    }
  }

  function boot(){
    guard();
    if(!build()){ setTimeout(boot, 250); return; }
    /* the snippet re-renders the stepper on step changes, so keep ours */
    if(typeof window.renderStepper === 'function' && !window.renderStepper.__v6){
      var orig = window.renderStepper;
      var wrapped = function(){
        var r = orig.apply(this, arguments);
        var s = document.getElementById('stepper');
        if(s) s.dataset.v6 = '';
        build();
        return r;
      };
      wrapped.__v6 = true;
      window.renderStepper = wrapped;
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot, 500); });
  } else {
    setTimeout(boot, 500);
  }
})();
